<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Customizations/Scoper_Customization';
    let nextLink= '/Documentation/Customizations/Validator_Customization';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="customization-of-the-typer-1"
  bind:intersecting={visibleById["customization-of-the-typer-1"]}
  onIntersectChange={(visible) => setVisible("customization-of-the-typer-1", visible)}
>Customization of the Typer</SectionComponent>
<p>The typer can be customized <strong>per concept</strong>.<br>
Your new typer must implement the <a
  href="/Documentation/Under_the_Hood/FreTool_Interfaces#fretyper-5"
><code>FreTyper</code> interface</a>.</p>
<p>As a convenience, Freon generates a file <code>~/freon/typer/CustomYourLanguageNameTyperPart.ts</code>,<br>
which will <strong>not</strong> be overwritten upon regeneration.<br>
It already contains a class that implements this interface, ready for your extensions.</p>
<SectionComponent tag="h2" 
  id="adding-typing-methods-2"
  bind:intersecting={visibleById["adding-typing-methods-2"]}
  onIntersectChange={(visible) => setVisible("adding-typing-methods-2", visible)}
>Adding Typing Methods</SectionComponent>
<p>In the new typer class, you can add custom logic to one or more methods.<br>
Let the method return <code>null</code> to indicate that the typer from the Freon Definition Level should be used instead.</p>
<p>The following example overrides the <code>conformsList</code> method for lists of <code>Variables</code>.<br>
It checks whether two lists conform when their elements appear in reverse order:<br>
for example, <code>[A, B, C]</code> conforms to <code>[C, B, A]</code>.</p>
<pre class="language-ts"><code class="language-ts">// CustomizationsProject/src/custom/typer/CustomEntityModelTyperPart.ts

// Generated by the Freon Language Generator.
import &#123; FreNode, FreType, FreTyper &#125; from "@freon4dsl/core";
import &#123;Variable&#125; from "../language/gen/index.js";
import &#123;EntityModelEnvironment&#125; from "../config/gen/EntityModelEnvironment.js";

/**
 * Class 'CustomEntityModelTyperPart' is meant to be a convient place to add any
 * custom code for type checking.
 */
export class CustomEntityModelTyperPart implements FreTyper &#123;
    mainTyper: FreTyper;

    isType(modelelement: FreNode): boolean | null &#123;
        return null;
    &#125;

    inferType(modelelement: FreNode): FreType | null &#123;
        return null;
    &#125;

    equals(type1: FreType, type2: FreType): boolean | null &#123;
        return null;
    &#125;

    conforms(type1: FreType, type2: FreType): boolean | null &#123;
        return null;
    &#125;

    /**
     * Example of custom typings: typelist2 conforms to typelist1 if the elements
     * conform in the opposite direction, i.e. [A, B, C] conforms to [C, B, A]
     * @param typelist1
     * @param typelist2
     */
    conformsList(typelist1: FreType[], typelist2: FreType[]): boolean | null &#123;
        if (typelist1.length &gt; 0 &amp;&amp; (typelist1[0] instanceof Variable)) &#123;
            if (typelist1.length !== typelist2.length) return false;
            let result: boolean = true;
            const max_length = typelist1.length;
            for (let i = 0; i &lt; typelist1.length; i++) &#123;
                result = EntityModelEnvironment.getInstance().typer.conforms(typelist1[i], typelist2[max_length - i]);
                if (result == false) return result;
            &#125;
            return result;
        &#125; else &#123;
            return null;
        &#125;
    &#125;

    commonSuper(typelist: FreType[]): FreType | null &#123;
        return null;
    &#125;

    public getSuperTypes(type: FreType): FreType[] | null &#123;
        return null;
    &#125;
&#125;
</code></pre>


<PrevNextSection {prevLink} {nextLink} />